import _ from "lodash"

export const naoVazio = valor => !!valor;
export const buscarPor = _.curry((prop, valor, obj) => obj[prop] === valor);
export const buscarPorId = buscarPor('id');
export const criarIntervalo = (inicio, fim) => 
    Array(fim-inicio).fill(0).map((x, i) => inicio + i);